const groupPrefix = createApiRoute(ApiModule.PRODUCTION_PLANNING, ApiModule.EMPLOYEE)

export const apiProductionReports = {
	exportPackagingReport: async (from: string, to: string) =>
		await apiCommon<Blob>(`${groupPrefix}/reports/packaging/export`, {
			method: 'GET',
			...createQuery(undefined, undefined, undefined, { from, to }),
			isFileDownload: true,
		}),

	exportPackagingMealsReport: async (from: string, to: string) =>
		await apiCommon<Blob>(`${groupPrefix}/reports/packaging-meals/export`, {
			method: 'GET',
			...createQuery(undefined, undefined, undefined, { from, to }),
			isFileDownload: true,
		}),

	exportSummaryRawMaterialsReport: async (from: string, to: string) =>
		await apiCommon<Blob>(`${groupPrefix}/reports/summary-raw-materials/export`, {
			method: 'GET',
			...createQuery(undefined, undefined, undefined, { from, to }),
			isFileDownload: true,
		}),

	exportProductsDeliveryReport: async (from: string, to: string) =>
		await apiCommon<Blob>(`${groupPrefix}/reports/products-delivery/export`, {
			method: 'GET',
			...createQuery(undefined, undefined, undefined, { from, to }),
			isFileDownload: true,
		}),

	exportVegetablesCuttingReport: async (from: string, to: string) =>
		await apiCommon<Blob>(`${groupPrefix}/reports/vegetables-fruits/export`, {
			method: 'GET',
			...createQuery(undefined, undefined, undefined, { from, to }),
			isFileDownload: true,
		}),
}
